import Nullstack from 'nullstack';
export default function IconAd({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-ad",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "3",
    y: "5",
    width: "18",
    height: "14",
    rx: "2"
  }), "   ", Nullstack.element("path", {
    d: "M7 15v-4a2 2 0 0 1 4 0v4"
  }), "   ", Nullstack.element("line", {
    x1: "7",
    y1: "13",
    x2: "11",
    y2: "13"
  }), "   ", Nullstack.element("path", {
    d: "M17 9v6h-1.5a1.5 1.5 0 1 1 1.5 -1.5"
  }), " ");
}